export const UPLOAD_BANNER = "UPLOAD_BANNER";
export const GET_BANNERS = "GET_BANNERS";
export const EDIT_BANNERS = "EDIT_BANNERS";
export const PAGINATION_PARAMS_BANNERS = "PAGINATION_PARAMS_BANNERS";
export const TOTAL_PAGES_BANNERS = "TOTAL_PAGES_BANNERS";
export const COUNT_BANNERS = "COUNT_BANNERS";
